module.exports = "/shared/img/fast-betting-btn.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/fast-betting-btn.png
// module id = 1
// module chunks = 13